export const CDN_URL = window.CDN_URL || "";

export default {
  CDN_URL,
};
